import { ToggleButtonGroup, ToggleButton, Box } from '@mui/material';
import { WindowOutlined, ListOutlined } from '@mui/icons-material';
import { ToggleViewProps } from './ToggleView.props';

export const ToggleView = ({
  value = 'grid',
  onChange,
  size = 'm',
  firstOptionLabel = 'Grid View',
  secondOptionLabel = 'List View',
  ...props
}: ToggleViewProps) => {
  return (
    <Box sx={{ display: 'inline-block', width: 'fit-content' }}>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={onChange}
        size={size}
        {...props}
      >
        <ToggleButton value="grid" aria-label={firstOptionLabel}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <WindowOutlined />
            <Box component="span">{firstOptionLabel}</Box>
          </Box>
        </ToggleButton>
        <ToggleButton value="list" aria-label={secondOptionLabel}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <ListOutlined />
            <Box component="span">{secondOptionLabel}</Box>
          </Box>
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default ToggleView;
